<template>
  <a-drawer
    width="65%"
    :visible="visible"
    :destroy-on-close="true"
    :title="`出勤详情（${projectName || '项目'}）`"
    :body-style="{ padding: '16px 16px 20px' }"
    @close="handleClose"
  >
    <div class="task-drawer-body">
      <div class="task-drawer-filters">
        <a-form layout="inline" class="task-filter-form">
          <a-form-item label="时间区间">
            <a-range-picker
              v-model="filters.dateRange"
              :allow-clear="true"
              :disabled-date="disabledDateAfterToday"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              placeholder="['开始日期', '结束日期']"
              class="filter-range-picker"
              @change="onFilterChange"
            />
          </a-form-item>
          <span class="task-filter-btns">
            <a-button type="primary" @click="handleQuery">查询</a-button>
            <a-button @click="resetQuery">重置</a-button>
          </span>
        </a-form>
      </div>

      <a-table
        :loading="loading"
        :columns="tableColumns"
        :data-source="list"
        :pagination="false"
        :row-key="rowKey"
        :scroll="{ x: 'max-content' }"
      />

      <a-pagination
        class="task-drawer-pagination"
        show-size-changer
        show-quick-jumper
        :current="query.pageNum"
        :total="total"
        :page-size="query.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="onPageChange"
      />
    </div>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { attendancePage } from '@/api/system/dept'

export default {
  name: 'AttendanceDetailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [Number, String],
      default: null
    },
    projectName: {
      type: String,
      default: ''
    },
    dateRange: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10
      },
      filters: {
        dateRange: []
      },
      columns: [
        { title: '员工', dataIndex: 'nickname', width: 120, customRender: (text) => text != null && text !== '' ? text : '-' },
        { title: '当前位置', dataIndex: 'spaceName', width: 140, customRender: (text) => text != null && text !== '' ? text : '-' },
        { title: '位置更新时间', dataIndex: 'uploadTime', width: 170, customRender: (text) => text != null && text !== '' ? text : '-' },
        { title: '工作流', dataIndex: 'hasWorkflow', width: 80, align: 'center', customRender: (text) => text != null && text !== '' ? text : '-' },
        { title: '启动', dataIndex: 'workflowStarted', width: 80, align: 'center', customRender: (text) => text != null && text !== '' ? text : '-' }
      ]
    }
  },
  computed: {
    tableColumns () {
      return [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => (this.query.pageNum - 1) * this.query.pageSize + index + 1
        },
        ...this.columns
      ]
    },
    rowKey () {
      return (record, index) => (record.uploadTime != null ? record.uploadTime : '') + '-' + index
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.query.pageNum = 1
        this.filters.dateRange = Array.isArray(this.dateRange) ? this.dateRange.slice(0, 2) : []
        this.fetchList()
      }
    },
    projectId () {
      if (this.visible) {
        this.query.pageNum = 1
        this.fetchList()
      }
    },
    dateRange () {
      if (this.visible) {
        this.filters.dateRange = Array.isArray(this.dateRange) ? this.dateRange.slice(0, 2) : []
      }
    }
  },
  methods: {
    disabledDateAfterToday (current) {
      if (!current) return false
      return current.isAfter(moment(), 'day')
    },
    handleClose () {
      this.$emit('update:visible', false)
    },
    onPageChange (page) {
      this.query.pageNum = page
      this.fetchList()
    },
    onShowSizeChange (current, size) {
      this.query.pageNum = 1
      this.query.pageSize = size
      this.fetchList()
    },
    onFilterChange () {
      this.query.pageNum = 1
    },
    handleQuery () {
      this.query.pageNum = 1
      this.fetchList()
    },
    resetQuery () {
      this.filters.dateRange = []
      this.query.pageNum = 1
      this.fetchList()
    },
    fetchList () {
      if (!this.projectId) {
        this.list = []
        this.total = 0
        return
      }
      const params = {
        projectId: this.projectId,
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        params.startTime = this.filters.dateRange[0]
        params.endTime = this.filters.dateRange[1]
      }
      this.loading = true
      attendancePage(params).then(res => {
        const data = res && res.data ? res.data : null
        this.list = (data && data.records) ? data.records : []
        this.total = (data && data.total) ? data.total : 0
      }).catch(() => {
        this.$message.error('获取出勤详情失败', 3)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.task-drawer-filters {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}

.task-filter-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;
}

.task-filter-form :deep(.ant-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

.task-filter-form :deep(.ant-form-item-label) {
  width: 72px;
  line-height: 32px;
  padding-right: 8px;
}

.filter-range-picker {
  width: 240px;
}

.task-filter-btns {
  margin-left: auto;
  display: inline-flex;
  gap: 8px;
}

.task-drawer-body :deep(.ant-table) {
  margin-bottom: 12px;
}

.task-drawer-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
</style>

